import Big from 'big.js';
import { AddCartItemParams } from 'smg/customer-api/carts';
import { HandleRequestError } from 'smg/errors';
import { G } from 'smg/querystring';
import { DollarFormat } from 'smg/util';
import * as carts from '../carts';

if (document.body.id === 'cart') {
    void main();
}

async function main() {
    const errorId = document.querySelector('#error-div') as HTMLElement;

    const quoteID = G().Get('quote');
    if (quoteID) {
        await carts.
            AddCartItem(
                { quoteID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    const orderID = G().Get('order');
    if (orderID) {
        await carts.
            AddCartItem(
                { orderID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    const newCartItem = G().Get('new');
    if (newCartItem) {
        try {
            await carts.AddCartItem(JSON.parse(newCartItem) as AddCartItemParams, {
                promptToCheckout: false,
            });
        } catch (e) {
            HandleRequestError(e);
        }
    }
    const cartID = G().Get('cart');
    if (cartID) {
        await carts.
            AddCartItem(
                { cartID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    void drawCart();
}

async function drawCart() {
    const cartResp = await carts.GetCart().catch(() => undefined);
    // Update Order Summary

    const $orderSummary = document.querySelector('#order-summary') as HTMLElement;
    const $subtotalAmt = $orderSummary.querySelector('#subtotal-amount') as HTMLElement;
    const $goToCheckoutBtn = $orderSummary.querySelector('#to-checkout') as HTMLButtonElement;

    const $cardContainer = document.querySelector('#cart-item-cards-container') as HTMLElement;
    const $emptyCartPlaceholder = document.querySelector('#cart-empty-placeholder') as HTMLElement;

    if (!cartResp?.cart.cartItems?.length) {
        $subtotalAmt.textContent = '$0.00';
        $goToCheckoutBtn.classList.add('disabled');
        $emptyCartPlaceholder.classList.remove('d-none');
        document.querySelectorAll('.cart-item-card:not(#cart-empty-placeholder)').forEach($el => $el.remove());
    } else {
        $goToCheckoutBtn.classList.remove('disabled');
        $emptyCartPlaceholder.classList.add('d-none');
        document.querySelectorAll('.cart-item-card:not(#cart-empty-placeholder)').forEach($el => $el.remove());
        const subtotalAmt = Big(cartResp.subtotal);

        $subtotalAmt.textContent = DollarFormat(subtotalAmt);
        if (cartResp.cart.cartItems) {
            for (const cartItem of cartResp.cart.cartItems) {
                const $card = await carts.DrawQuoteOrOrderCartItem({
                    cartItem,
                    deleteSuccess: drawCart,
                    restoreSuccess: drawCart,
                });
                if (!$card) {
                    continue;
                }
                $cardContainer.appendChild($card);
            }
        }
    }
    document.querySelector('#cart-item-card-loading-placeholder')?.remove();
}